define([
    'santa-components',
    'lodash',
    'skins',
    'youTubeSubscribeButton/skins/skins.json',
    'componentsCore'
], function (santaComponents, _, skinsPackage, skinsJson, componentsCore) {
    'use strict';

    const SIZES = {
        'default': {width: 145, height: 33},
        full: {width: 212, height: 55},
        extraSpace: {width: 150, height: 60}
    };

    const IFRAME_SIZE = {width: 212, height: 66};
    const IFRAME_SIZE_IE = {width: 212, height: 67};

    const getLayoutType = props => {
        if (props.compProp.layout === 'default') {
            return 'default';
        }

        return props.browser.ie ? 'fullIE' : 'full';
    };

    const calcCompDimensions = (props, state) => {
        const layoutType = state.$layout;
        const relevantStaticSize = layoutType === 'default' ? _.clone(SIZES.default) : _.clone(SIZES.full);

        return relevantStaticSize;
    };

    const calcIframeDimensions = (props, state) => {
        const iframeSize = _.clone(props.browser.ie ? IFRAME_SIZE_IE : IFRAME_SIZE);

        if (state.$hoverMode === 'hoverMode') {
            iframeSize.width += SIZES.extraSpace.width;
            iframeSize.height += SIZES.extraSpace.height;
        }

        return iframeSize;
    };

    /**
     * @class components.YouTubeSubscribeButton
     * @extends {core.skinBasedComp}
     */
    const youTubeSubscribeButton = {
        displayName: 'YouTubeSubscribeButton',
        mixins: [componentsCore.mixins.skinBasedComp],
        propTypes: {
            browser: santaComponents.santaTypesDefinitions.Browser.browser.isRequired,
            compData: santaComponents.santaTypesDefinitions.Component.compData.isRequired,
            compProp: santaComponents.santaTypesDefinitions.Component.compProp.isRequired,
            santaBase: santaComponents.santaTypesDefinitions.santaBase.isRequired,
            style: santaComponents.santaTypesDefinitions.Component.style.isRequired
        },

        getInitialState() {
            return {
                $layout: getLayoutType(this.props),
                $hoverMode: 'nonHover'
            };
        },

        componentWillReceiveProps(nextProps) {
            this.setState({
                $layout: getLayoutType(nextProps)
            });
        },

        getIFrameSrc() {
            const htmlUrl = `${this.props.santaBase}/static/external/youtubeSubscribeButton.html?`;
            const params = [];
            params.push(`channel=${this.props.compData.youtubeChannelId}`);
            params.push(`layout=${this.props.compProp.layout}`);
            params.push(`theme=${this.props.compProp.theme}`);
            return htmlUrl + params.join('&');
        },

        onMouseOut() {
            this.setState({
                $hoverMode: 'nonHover'
            });
        },

        onMouseEnter() {
            this.setState({
                $hoverMode: 'hoverMode'
            });
        },

        getSkinProperties() {
            const compDimensions = calcCompDimensions(this.props, this.state);
            const iframeDimensions = calcIframeDimensions(this.props, this.state);
            const frameProps = {
                'data-src': this.getIFrameSrc(),
                allowFullScreen: true,
                frameBorder: '0',
                width: '100%',
                height: '100%',
                onMouseOut: this.onMouseOut,
                onMouseEnter: this.onMouseEnter
            };

            return {
                '': {
                    style: compDimensions
                },
                hitWidth: {
                    style: {left: compDimensions.width}
                },
                youtubeIframe: {
                    addChildren: [
                        santaComponents.utils.createReactElement('iframe', frameProps)
                    ],
                    style: iframeDimensions
                }
            };
        }
    };

    componentsCore.compRegistrar.register('wysiwyg.common.components.youtubesubscribebutton.viewer.YouTubeSubscribeButton', youTubeSubscribeButton);
    skinsPackage.skinsMap.addBatch(skinsJson);

    return youTubeSubscribeButton;
});
